import Statistic from "./Statistic";
import request from "../../../request";

export default function Tokens() {

   return <Statistic
      title="Tokens"
      variant="pie"
      fetchData={async (from, to) => {

         const res = await request.get('/api/general/reports/tokens', { params: { from, to } });
         const { count } = res.data;

         const cards = [
            {
               title: "Generated",
               number: count.generated
            },
            {
               title: "Awaiting",
               number: count.awaiting_generation
            }
         ];

         return [ { cards }]
      }}
   />
}